import React, { useEffect } from 'react';
import '../styles/Services.css';

const services = [
  {
    title: "Cricket Exchange",
    image: "cricketservices.webp",
  },
  {
    title: "Soccer Trading",
    image: "footballservices.webp",
  },
  {
    title: "Horse Racing",
    image: "horseraceservices.webp",
  },
  {
    title: "Teen Patti & Rummy",
    image: "indiancardservices.webp",
  },
  {
    title: "Tennis Exchange",
    image: "tennisservices.webp",
  },
  {
    title: "Live Casino",
    image: "casinoservices.webp",
  },
];

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="services-page">
      <header className="hero-section">
        <h1 className="hero-title">Our Exclusive <span className="highlight">Services</span></h1>
        <p className="hero-description">
          At Mahadev Book, we bring you the most dynamic and trusted gaming platform in the industry. Whether you're passionate about cricket, football, tennis, or classic card games, we've got you covered with a diverse array of options to keep you entertained.
          Our platform is designed for both beginners and seasoned players, ensuring a seamless experience with high-end security, instant deposits, and 24/7 customer support. Join thousands of satisfied users who trust Mahadev for a reliable and rewarding journey into the world of online gaming.
        </p>
      </header>

      <section className="services-section">
        <h2 className="section-title">Top <span className='highlight'>Mahadev</span> Picks</h2>
        <div className="service-cards">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <img src={service.image} alt={service.title} className="service-image" />
              <h3 className="service-title">{service.title}</h3>
            </div>
          ))}
        </div>
        <div className="service-btn">
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us @ 7777857777
          </a>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            WhatsApp Us @ 7777077773
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;
